import { NovidadesService, ResponseNovidade } from '@/services/novidades/novidades.service';
import { defineStore } from 'pinia';

const LAST_SEEN_KEY = 'whiz_novidades_last_seen';

/**
 * Momento em que a novidade chegou para o cliente: a PUBLICAÇÃO, não a criação. Publicar
 * um rascunho antigo tem de acender a bolinha. Servidor sem a coluna cai na criação.
 */
export function dataDeChegada(n: Pick<ResponseNovidade, 'data' | 'dataPublicacao'>): number {
  return new Date(n.dataPublicacao ?? n.data).getTime();
}

/** Há novidade publicada depois do último "visto" deste navegador? */
export function temNovidadeDepoisDe(
  novidades: Pick<ResponseNovidade, 'data' | 'dataPublicacao'>[],
  ultimoVisto: string,
): boolean {
  const visto = new Date(ultimoVisto).getTime();
  return novidades.some((n) => dataDeChegada(n) > visto);
}

export const useNovidadesStore = defineStore('novidades-user', {
  state: () => ({
    novidades: [] as ResponseNovidade[],
    hasNew: false,
    loaded: false,
    service: new NovidadesService(),
  }),
  actions: {
    async load() {
      try {
        this.novidades = await this.service.getPublicadas();
        this._checkForNew();
      } catch {
        // silently fail — feature is non-critical
      } finally {
        this.loaded = true;
      }
    },
    _checkForNew() {
      if (this.novidades.length === 0) {
        this.hasNew = false;
        return;
      }
      const lastSeen = localStorage.getItem(LAST_SEEN_KEY);
      if (!lastSeen) {
        this.hasNew = true;
        return;
      }
      this.hasNew = temNovidadeDepoisDe(this.novidades, lastSeen);
    },
    markAsSeen() {
      localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
      this.hasNew = false;
    },
    /** Botão "Entendi": registra o acesso de todas as novidades exibidas no backend. */
    async confirmarLeitura() {
      this.markAsSeen();
      const ids = this.novidades.map((n) => n.id);
      if (ids.length === 0) return;
      try {
        await this.service.registrarVisualizacoes(ids);
      } catch {
        // silently fail — feature is non-critical
      }
    },
  },
});
